import { render, staticRenderFns } from "./PDPCommentNode.vue?vue&type=template&id=0839567c&scoped=true&"
import script from "./PDPCommentNode.vue?vue&type=script&lang=js&"
export * from "./PDPCommentNode.vue?vue&type=script&lang=js&"
import style0 from "./PDPCommentNode.vue?vue&type=style&index=0&id=0839567c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0839567c",
  null
  
)

export default component.exports